import { useEffect, useRef, useState } from 'react';
import { Users, Phone, Mail, Calendar, Plane, Globe, PhoneCall, BanknoteArrowUp } from 'lucide-react';

// import ThankYouPage from './components/ThankYouPage';
import Select from "react-select";
import { GetCountryList } from '../../Redux/Action/CorporateAction';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router';
import Loader from './Loader';
import animationData from '../../images/registration.json'
import doctorimg from '../../images/Login/pleased-middle-aged-female-doctor-wearing-medical-robe-with-stethoscope-sitting-desk-work-laptop-with-medical-tools-speaks-phone-points-with-hand-side-green-wall (1).jpg'
import vfs_logo from '../../images/Register/vfs_global_logo.png'
import vasco_logo from '../../images/Register/one_vasco_logo.png'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { VfsRefundRequest } from '../Modal/VfsModal/VfsRefundRequest';
import { TeamAndConditionsModel } from '../Modal/VfsModal/TeamAndConditionsModel';
import { DisclaimerModel } from '../Modal/VfsModal/DisclaimerModel';

const reviews = [
    {
      name: "Mr. Sujith Raju",
      text: "The consultation process was smooth and online, which was super convenient. My assigned doctor was professional, kind and took the time to really understand my health problems. I am grateful to be with Welcome Cure.",
    //   image: ic_dinesh_tyagi,
    },
    {
      name: "Mr. Santosh Kumar",
      text: "Before calling you, I was very confused about what to do. But the 5-minute call with you cleared many doubts, and also you helped me with the solution to my issue in a few seconds. Thank you.",
    //   image: img2,
    },
    {
      name: "Mrs. Meena ",
      text: "Thanks a lot. Wonderful experience. I have never come across such a service in my lifetime. I recommend it for everyone. Please keep it up.",
    //   image: ic_veeral_luvani,
    },
    {
        name: "Mr. Aravindh",
        text: "The service on the app was courteous and professional, making the whole experience smooth and reassuring.",
    },
    {
        name: "Mrs. Sudhaben Sanjaykumar",
        text: "Thank you so much for checking in. Yes, I was able to connect with the doctor and have received my prescription. I truly appreciate the support and prompt service throughout the process. I'm feeling better already, and I'm very satisfied with the care and assistance I received. I'd be happy to share a quick experience was also saved my time as well. Thanks again for your excellent service!",
    },
    {
        name: "Mrs.Thampija Thampidhas",
        text: "I recently used the Doc on Call service from Welcome Cure, the response was prompt."
    },
    {
        name: "Mr. Suresh ",
        text: "We recently reached out to Welcome Cure Health Concierge when my father was experiencing pain in his ear. The response was incredibly prompt - within minutes, we were connected to a doctor over a video call. The consultation was smooth, professional, and reassuring. In less than 30 minutes, we had a proper diagnosis and a prescription in hand. I'm truly impressed by the speed and efficiency of their service. It gave us peace of mind during a stressful moment. Highly recommended!",
    },
    {
        name: "Mr.Rahul ",
        text: "Hey Hii!, This is Rahul, today I just got a appointment with Welcome Cure One Consultant doctor Dr.Sally. Her response response was so nice and she gave me some Prescription to apply. And Finally a very Quick Response from the welcome cure one to get an appointment with doctor. Thank you for your Consen.",
    },
    {
        name: "Mrs. Anahita",
        text: "Hi, Dr was very professional and at the same time caring",
    }
  ];
function App() {
    const [countryCodeoption, setCountryCodeOption] = useState("");
    const [isloading, setIsloading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const branchId = params.get("_id")

    const defaultOption = {
        loop: true,
        autoplay: true,
        animationData: animationData,
    };
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        countryCode: 91,
        sourceCountry: '',
        destinationCountry: '',
        isPrimary : true
    });

    const [showFamilyMember, setShowFamilyMember] = useState(false);

    const [familyMembers, setFamilyMembers] = useState([]); 

      const handleFamilyMemberChange = (index, field , value) => {
        const updatedMembers = [...familyMembers];
        updatedMembers[index][field] = value;
        setFamilyMembers(updatedMembers);
        // If the field changed is name, check for uniqueness
  if (field === "name") {
    const allNames = [
      formData.name,
      ...updatedMembers.map(member => member.name)
    ];
    const nameSet = new Set(allNames.filter(Boolean));
    if (nameSet.size === allNames.filter(Boolean).length) {
      setErrorName("");
    }
  }
      };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // If the field changed is name, check for uniqueness
  if (name === "name") {
    const allNames = [
      formData.name,
      ...familyMembers.map(member => member.name)
    ];
    const nameSet = new Set(allNames.filter(Boolean));
    if (nameSet.size === allNames.filter(Boolean).length) {
      setErrorName("");
    }
  }
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const [countryOption, setCountryOption] = useState("");

    useEffect(() => {
        dispatch(GetCountryList());
    }, [dispatch]);

    const countryList = useSelector((state) => state?.corporateData?.CountryList?.data);

    useEffect(() => {
        if (countryList && countryList?.length > 0) {
            const con = countryList.map((item) => ({
                label: item.name,
                value: item.id,
                phonecode: item.phonecode,
            }));
            setCountryOption(con);
        }
    }, [countryList]);
    useEffect(() => {
        if (countryList && countryList?.length > 0) {
            const con = countryList.map((item) => ({
                label: `+${item.phonecode}`,
                value: item.phonecode,
            }));
            setCountryCodeOption(con);
        }
    }, [countryList]);

    const [errorName , setErrorName] = useState("")
    // for payment
        const handleSubmit = async (e) => {
        e?.preventDefault();
        const formDataArray = [{ ...formData }];
        setIsloading(true);
        try {
            const data = { currency: "INR", amount: 300 , branchId: branchId, member: formDataArray };
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/create-payment-link`, data);
            const newdata = response.data;
            if (newdata && newdata.payment_link_url) {
                window.location.href = newdata.payment_link_url;
                setIsloading(false);
            } else {
                toast.error("Error creating payment link!");
                setIsloading(false);
            }
        } catch (error) {
            console.error("Payment setup failed", error);
            toast.error("Failed to initialize payment. Please try again.");
            setIsloading(false);
        }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: state.isFocused ? '#fff100' : '#ececec',
            boxShadow: 'none',
            backgroundColor: '#fff',
            '&:hover': { borderColor: '#ececec' },
        }),
        placeholder: (base) => ({
            ...base,
            color: '#262626',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '2px 8px',
            height: '38px',
            overflow: 'hidden',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            color: '#262626',
            height: '38px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            color: 'black',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                backgroundColor: '#f8f8f8',
            },
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            padding: 0,
        }),
    };

    const customStylescountrycode = {
        control: (provided, state) => ({
            ...provided,
            minWidth: '100px',
            maxWidth: '120px',
            overflow: 'ellipsis',
            whiteSpace: 'nowrap',
            // maxWidth: window?.innerWidth > 600 && '210px',
            borderColor: state.isFocused ? '#fff100' : '#ececec',
            boxShadow: 'none',
            backgroundColor: '#fff',
            '&:hover': { borderColor: '#ececec' },
        }),
        placeholder: (base) => ({
            ...base,
            color: '#262626',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '2px 4px',
            height: '50px',
            overflow: 'hidden',
            borderColor: '#d1d5db',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            color: '#262626',
            height: '50px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            color: 'black',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                backgroundColor: '#f8f8f8',
            },
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            padding: 0,
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            padding: '0 4px',
        }),
    };

    const customComponents = {
        IndicatorSeparator: () => null,
    };

    const [currentIndex, setCurrentIndex] = useState(0);
    const sliderRef = useRef(null);
  
    const settings = {
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      pauseOnHover: true,
      beforeChange: (_, next) => setCurrentIndex(next), // Update index when slide changes
    };
    const logos = [
       vfs_logo,
       vasco_logo
      ];
      
    const infiniteLogos = [...logos, ...logos,...logos]; // Duplicate logos for seamless scrolling
    
    const handleAddFamilyMember = () => {
        if(!showFamilyMember) setShowFamilyMember(true);
        setFamilyMembers(prev => [
            ...prev,
            { ...formData , name: ''}
          ]);
          setErrorName("")
    }
    const handleDeleteFamilyMember = (index) => {
        setFamilyMembers((prevMembers) =>
          prevMembers.filter((_, i) => i !== index)
        );
      };
      const [checkbox, setCheckbox] = useState(false);
      const [teamConditionCheckbox, setTeamConditionCheckbox] = useState(false);
      const [teamCheckBoxDisplay, setTeamCheckBoxDisplay] = useState(false);
      const [refundModal, setRefundModal] = useState(false);
      const [teamConditionModal, setTeamConditionModal] = useState(false);
      const [disclaimerModal, setDisclaimerModal] = useState(false);

      useEffect(() => {
          setTeamConditionCheckbox(teamCheckBoxDisplay);
        },
      []);
      
    return (
      <>
        {isloading && (
          <div>
            <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-[999] bg-opacity-50">
              <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <Loader />
              </div>
            </div>
          </div>
        )}
        <ToastContainer />
        <div className="min-h-screen bg-gray-50">
          {/* Header */}
          <header
            className={`sticky top-0 ${
              refundModal ? "z-20" : "z-50"
            } bg-white shadow-lg transition-all duration-300`}
          >
            <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
              <div className="flex justify-between items-center py-4">
                <div className="flex items-center space-x-3">
                  <img src="data:image/png;base64,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"></img>
                </div>
              </div>
            </div>
          </header>

          {/* Hero Section */}
          <section className="relative text-white bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800">
            {/* <div className="absolute inset-0 bg-black opacity-10"></div> */}

            <div className="flex relative flex-col gap-2 justify-between px-4 py-10 mx-auto max-w-7xl lg:flex-row lg:items-center sm:px-6 lg:px-8">
              <div className="text-left">
                <h2 className="mb-6 text-3xl font-bold leading-tight md:text-[45px]">
                  Global Doctor-on-Call Service
                  <span className="block text-yellow-300  text-[25px] md:text-[30px]">
                    Your well-being in unknown geographies is our top priority!
                  </span>
                </h2>
                <p className="mb-8 max-w-lg text-xl leading-relaxed text-blue-100 md:text-2xl">
                  Take care of your health, even when you're away from home.
                </p>
                <div className="flex flex-col gap-4 sm:flex-row justify-left">
                  <button
                    onClick={() => {
                      const section = document.getElementById("register");
                      if (section) {
                        section.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }
                    }}
                    className="bg-[#FCDD00] text-center text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-yellow-400 transform hover:scale-105 transition-all duration-300 shadow-lg"
                  >
                    Get Started Today
                  </button>
                </div>
              </div>
              <div className="max-w-[100%] md:max-w-[100%] lg:max-w-[550px] mt-5 lg:mt-0">
                {/* <Lottie options={defaultOption} /> */}
                <img
                  src={doctorimg}
                  alt="doctorimg"
                  className="rounded-3xl"
                ></img>
              </div>
            </div>
          </section>

          {/* Services Section */}
          <section id="services" className="py-20 bg-gray-50">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
              <div className="mb-16 text-center">
                <h3 className="mb-4 text-4xl font-bold text-gray-900">
                  Our Doctor Consultation Service
                </h3>
                <p className="mx-auto max-w-xl text-xl text-gray-600">
                  Remote doctor consultations wherever you go.
                </p>
                <p className="mx-auto max-w-xl text-xl text-gray-600">
                  Activate doctor consultation services at just{" "}
                  <span className="text-2xl font-bold">₹300!</span>
                </p>
                <p className="mx-auto text-xl text-gray-600">
                  1 Month validity of Doc-on-Call service during your
                  international travel.
                </p>
              </div>

              <div className="grid gap-8 md:grid-cols-3">
                {/* Travel-Friendly Consultations */}
                <div className="p-8 text-center bg-gray-50 rounded-2xl transition-all duration-300 transform hover:shadow-xl hover:-translate-y-2">
                  <div className="flex justify-center items-center mx-auto mb-6 w-16 h-16 bg-blue-100 rounded-full">
                    <Plane className="w-8 h-8 text-blue-600" />
                  </div>
                  <h4 className="mb-4 text-2xl font-semibold text-gray-900">
                    Travel-Friendly Consultations
                  </h4>
                  <p className="leading-relaxed text-gray-600">
                    Designed for travelers on the move
                  </p>
                </div>

                {/* Seamless Telehealth Access */}
                <div className="p-8 text-center bg-gray-50 rounded-2xl transition-all duration-300 transform hover:shadow-xl hover:-translate-y-2">
                  <div className="flex justify-center items-center mx-auto mb-6 w-16 h-16 bg-green-100 rounded-full">
                    <PhoneCall className="w-8 h-8 text-green-600" />
                  </div>
                  <h4 className="mb-4 text-2xl font-semibold text-gray-900">
                    Seamless Telehealth Access
                  </h4>
                  <p className="leading-relaxed text-gray-600">
                    Get seamless medical support via <br />
                    Tele-medicine.
                  </p>
                </div>

                {/* Global Health Expertise */}
                <div className="p-8 text-center bg-gray-50 rounded-2xl transition-all duration-300 transform hover:shadow-xl hover:-translate-y-2">
                  <div className="flex justify-center items-center mx-auto mb-6 w-16 h-16 bg-purple-100 rounded-full">
                    <Globe className="w-8 h-8 text-purple-600" />
                  </div>
                  <h4 className="mb-4 text-2xl font-semibold text-gray-900">
                    Global Health Expertise
                  </h4>
                  {/* <p className="leading-relaxed text-gray-600">
                                Consult with Global General Practitioner Doctors (GPs)
                                </p> */}
                  <p className="leading-relaxed text-gray-600">
                    Consult with Experienced & Global
                  </p>
                  <p className="leading-relaxed text-gray-600">
                    General Practitioner (GP) Doctors
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section id="pricing" className="py-20 bg-white">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
              {/* Pricing Section */}
              <div
                id="pricing"
                className="p-8 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-3xl"
              >
                <div className="mb-8 text-center">
                  <h4 className="mb-4 text-3xl font-bold text-gray-900">
                    Transparent Pricing
                  </h4>
                  <p className="text-lg text-gray-600">
                    Quality Healthcare via Global Doctor Consultations at an
                    Affordable Price Point
                  </p>
                </div>

                <div className="p-8 mx-auto max-w-md bg-white rounded-2xl border-2 border-blue-200 shadow-lg">
                  <div className="text-center">
                    <div className="mb-7 text-5xl font-bold text-blue-600">
                      ₹300
                    </div>
                    {/* <p className="mb-6 text-gray-600">Per Consultation</p> */}

                    <ul className="mb-8 space-y-3 text-left">
                      <li className="flex items-center">
                        <div className="mr-3 w-2 h-2 bg-green-500 rounded-full"></div>
                        <span className="text-gray-700">
                          Health Consultations from Global Doctors
                        </span>
                      </li>
                      <li className="flex items-center">
                        <div className="mr-3 w-2 h-2 bg-green-500 rounded-full"></div>
                        <span className="text-gray-700">
                          International / Local Prescriptions if required
                        </span>
                      </li>
                      <li className="flex items-center">
                        <div className="mr-3 w-2 h-2 bg-green-500 rounded-full"></div>
                        <span className="text-gray-700">
                          Follow-up Consultations
                        </span>
                      </li>
                      <li className="flex items-center">
                        <div className="mr-3 w-2 h-2 bg-green-500 rounded-full"></div>
                        <span className="text-gray-700">
                          Digital Health Records & Health Tips
                        </span>
                      </li>
                      <li className="flex items-center">
                        <div className="mr-3 w-2 h-2 bg-green-500 rounded-full"></div>
                        <span className="text-gray-700">
                          1 Month Validity from your date of travel
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Some of Our Clients */}
          <section id="clients" className="py-20 bg-gray-50">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
              <div className="mb-6 text-center md:mb-16">
                <h3 className="text-4xl font-bold text-gray-900">
                  Our Travel Partners
                </h3>
              </div>
              {/* Mobile-only Infinite Scroll Logos */}
              <div className="overflow-hidden relative md:hidden">
                <div className="flex gap-8 py-4 w-max animate-marquee">
                  {[...logos, ...logos].map((logo, index) => (
                    <img
                      key={index}
                      src={logo}
                      alt={`Client ${index + 1}`}
                      className="object-contain w-auto h-16"
                    />
                  ))}
                </div>
              </div>

              {/* <div className="flex overflow-hidden relative justify-center">
                            <div className="block py-4 space-x-6 whitespace-nowrap md:hidden animate-marquee">
                                {   
                                    [...infiniteLogos, ...infiniteLogos].map((logo, index) => (
                                        <Image
                                            key={index}
                                            src={logo}
                                            alt={`Client ${index + 1}`}
                                            className="inline-block object-contain w-auto h-16"
                                        />
                                    ))
                                }
                            </div>
                        </div> */}
              {/* <div className="relative w-full max-w-[1248px] overflow-hidden mt-6 sm:mt-8 md:mt-[32px]">
          <div className="flex gap-2 items-center w-max sm:gap-3 md:gap-4 animate-scroll">
            {infiniteLogos.map((logo, index) => (
              <div key={index} className="flex items-center justify-center p-4 min-w-[200px]">
                <img
                  src={logo}
                  alt={`logo-${index}`}
                  className="w-32 sm:w-40 md:w-[200px] h-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div> */}
              <style jsx>{`
                @keyframes marquee {
                  0% {
                    transform: translateX(0%);
                  }
                  100% {
                    transform: translateX(-50%);
                  }
                }
                .animate-marquee {
                  animation: marquee 20s linear infinite;
                }
              `}</style>

              <div className="hidden mx-auto max-w-xl md:grid md:grid-cols-2 lg:grid-cols-2">
                <img
                  src={vfs_logo}
                  alt="Client 1"
                  className="object-contain w-full h-16 bg-transparent"
                />
                <img
                  src={vasco_logo}
                  alt="Client 2"
                  className="object-contain w-full h-16"
                />
              </div>
            </div>
          </section>

          {/* See what our travelers have to say about us */}
          <section id="testimonials" className="py-20 bg-white">
            <div className="flex flex-col justify-center items-center px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
              <h3 className="mb-4 text-4xl font-bold text-center text-gray-900">
                See What Our Travelers Have to Say About Us
              </h3>
              {/* Review Slider */}
              <div className="relative mt-8 bg-gray-50 rounded-[16px] p-6 md:p-12 max-w-[1100px] w-full  flex flex-col items-center transition-transform duration-300 ease-in-out">
                <Slider
                  ref={sliderRef}
                  {...settings}
                  className="w-full p-[20px] sm:p-0"
                >
                  {reviews.map((review, index) => (
                    <div
                      key={index}
                      className="flex flex-col justify-center items-center"
                    >
                      {/* <Image
                src={review.image} // Default image fallback
                alt={review.name}
                width={100}
                height={100}
                className="rounded-full w-24 h-24 md:w-[100px] md:h-[100px] mx-auto"
              /> */}
                      <h3 className="font-bold text-lg md:text-[20px] text-[#181818] mt-4 text-center">
                        {review.name}
                      </h3>
                      <p className="text-gray-600 mt-4 md:mt-8 max-w-[800px] mx-auto text-center ">
                        {review.text.length > 500
                          ? `${review.text.substring(0, 500)}...`
                          : review.text}
                      </p>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>

            {/* Separate Navigation Dots */}
            <div className="flex justify-center gap-2 mt-[30px]">
              {reviews.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setCurrentIndex(index);
                    sliderRef.current.slickGoTo(index);
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? "bg-[#E7A100] scale-100"
                      : "bg-[#dac89f] scale-90 hover:bg-[#dac89f]"
                  }`}
                />
              ))}
            </div>
          </section>

          {/* Registration Form */}
          <section id="register" className="pt-12 pb-20 bg-gray-50">
            <div className="px-4 mx-auto max-w-4xl sm:px-6 lg:px-8">
              <div className="my-12 text-center">
                <h3 className="mb-4 text-4xl font-bold text-gray-900">
                  Register Your Detail
                </h3>
                <p className="text-xl text-gray-600">
                  Fill in your details to get started with our Doctor on Call
                  service
                </p>
              </div>

              <div className="px-4 py-6 bg-white rounded-3xl shadow-xl md:py-8 md:px-8">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid gap-6 md:grid-cols-2">
                    <div>
                      <label
                        htmlFor="name"
                        className="block mb-2 text-sm font-semibold text-gray-700"
                      >
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 placeholder:text-[14px] md:placeholder:text-[16px] border border-gray-300 rounded-[4px] focus:ring-0 focus:ring-transparent focus:border-transparent transition-all duration-300"
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-semibold text-gray-700"
                      >
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 placeholder:text-[14px] md:placeholder:text-[16px]  border border-gray-300 rounded-[4px] focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                        placeholder="Enter your email address"
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="contact"
                      className="block mb-2 text-sm font-semibold text-gray-700"
                    >
                      Mobile Number *
                    </label>
                    <div className="flex">
                      <Select
                        options={countryCodeoption}
                        components={customComponents}
                        placeholder="Select country code"
                        name="countryCode"
                        id="countryCode"
                        value={
                          countryCodeoption &&
                          countryCodeoption?.find(
                            (option) => option.value == formData.countryCode
                          )
                        }
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            countryCode: e.value,
                          }));
                        }}
                        menuPlacement="top"
                        isSearchable={true}
                        styles={customStylescountrycode}
                        className="w-[100px] sm:w-[120px] " // fixed width select
                        required
                      />
                      <input
                        type="number"
                        id="contact"
                        name="contact"
                        value={formData.contact}
                        onChange={handleInputChange}
                        required
                        className="flex-1 min-w-0 placeholder:text-[14px] md:placeholder:text-[16px] 
                        pl-2 sm:px-4 py-3 border border-l-0 border-gray-300 rounded-r-[4px] 
                        focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300
                        [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        placeholder="Enter your mobile number"
                      />
                    </div>
                  </div>

                  <div className="grid gap-6 md:grid-cols-2">
                    <div>
                      <label
                        htmlFor="sourceCountry"
                        className="block mb-2 text-sm font-semibold text-gray-700"
                      >
                        Source Country *
                      </label>
                      <Select
                        options={countryOption}
                        placeholder="Select Country"
                        name="sourceCountry"
                        id="sourceCountry"
                        value={
                          countryOption &&
                          countryOption?.find(
                            (option) => option.value === formData.sourceCountry
                          )
                        }
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            sourceCountry: e.value,
                          }));
                        }}
                        menuPlacement="top"
                        isSearchable={true}
                        styles={customStyles}
                        required
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="destinationCountry"
                        className="block mb-2 text-sm font-semibold text-gray-700"
                      >
                        Destination Country *
                      </label>
                      <Select
                        options={countryOption}
                        name="destinationCountry"
                        id="destinationCountry"
                        placeholder="Select Country"
                        value={
                          countryOption &&
                          countryOption?.find(
                            (option) =>
                              option.value === formData.destinationCountry
                          )
                        }
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            destinationCountry: e.value,
                          }));
                        }}
                        menuPlacement="top"
                        isSearchable={true}
                        styles={customStyles}
                        required
                      />
                    </div>
                  </div>

                  {showFamilyMember == true &&
                    familyMembers?.map((member, index) => (
                      <div
                        key={index}
                        className="p-4 mt-8 space-y-4 rounded-lg border shadow-sm"
                      >
                        <div className="flex justify-between items-center">
                          <h3 className="text-lg font-semibold">
                            Family Member {index + 1}
                          </h3>
                          <button
                            type="button"
                            onClick={() => handleDeleteFamilyMember(index)}
                            className="text-sm font-medium text-red-600 hover:underline"
                          >
                            Delete
                          </button>
                        </div>
                        <div className="grid gap-6 md:grid-cols-2">
                          <div>
                            <label className="block mb-2 text-sm font-semibold text-gray-700">
                              Full Name *
                            </label>
                            <input
                              type="text"
                              value={member.name}
                              onChange={(e) =>
                                handleFamilyMemberChange(
                                  index,
                                  "name",
                                  e.target.value
                                )
                              }
                              required
                              className="w-full px-4 py-3 placeholder:text-[14px] border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                              placeholder="Enter full name"
                            />
                            {errorName && (
                              <p className="text-red-500">{errorName}</p>
                            )}
                          </div>

                          <div>
                            <label className="block mb-2 text-sm font-semibold text-gray-700">
                              Email Address *
                            </label>
                            <input
                              type="email"
                              value={member.email}
                              onChange={(e) =>
                                handleFamilyMemberChange(
                                  index,
                                  "email",
                                  e.target.value
                                )
                              }
                              required
                              className="w-full px-4 py-3 placeholder:text-[14px] border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                              placeholder="Enter email"
                            />
                          </div>
                        </div>

                        <div>
                          <label
                            htmlFor="mobile"
                            className="block mb-2 text-sm font-semibold text-gray-700"
                          >
                            Mobile Number *
                          </label>
                          <div className="flex">
                            <Select
                              options={countryCodeoption}
                              components={customComponents}
                              placeholder="Select country code"
                              name="countryCode"
                              id="countryCode"
                              value={
                                countryCodeoption &&
                                countryCodeoption?.find(
                                  (option) => option.value == member.countryCode
                                )
                              }
                              onChange={(e) => {
                                handleFamilyMemberChange(
                                  index,
                                  "countryCode",
                                  e.value
                                );
                              }}
                              menuPlacement="top"
                              isSearchable={true}
                              styles={customStylescountrycode}
                              required
                            />
                            <input
                              type="number"
                              id="contact"
                              name="contact"
                              value={member.contact}
                              onChange={(e) =>
                                handleFamilyMemberChange(
                                  index,
                                  "contact",
                                  e.target.value
                                )
                              }
                              required
                              className="flex-1 placeholder:text-[14px] md:placeholder:text-[16px]  pl-2 sm:px-4 py-3 border border-l-0 border-gray-300 rounded-r-[4px] focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                              placeholder="Enter your mobile number"
                            />
                          </div>
                        </div>

                        <div className="grid gap-6 md:grid-cols-2">
                          <div>
                            <label
                              htmlFor="sourceCountry"
                              className="block mb-2 text-sm font-semibold text-gray-700"
                            >
                              Source Country *
                            </label>
                            <Select
                              options={countryOption}
                              placeholder="Select Country"
                              name="sourceCountry"
                              id="sourceCountry"
                              value={
                                countryOption &&
                                countryOption?.find(
                                  (option) =>
                                    option.value === member.sourceCountry
                                )
                              }
                              onChange={(e) => {
                                handleFamilyMemberChange(
                                  index,
                                  "sourceCountry",
                                  e.value
                                );
                              }}
                              menuPlacement="top"
                              isSearchable={true}
                              styles={customStyles}
                              required
                            />
                          </div>

                          <div>
                            <label
                              htmlFor="destinationCountry"
                              className="block mb-2 text-sm font-semibold text-gray-700"
                            >
                              Destination Country *
                            </label>
                            <Select
                              options={countryOption}
                              name="destinationCountry"
                              id="destinationCountry"
                              placeholder="Select Country"
                              value={
                                countryOption &&
                                countryOption?.find(
                                  (option) =>
                                    option.value === member.destinationCountry
                                )
                              }
                              onChange={(e) => {
                                handleFamilyMemberChange(
                                  index,
                                  "destinationCountry",
                                  e.value
                                );
                              }}
                              menuPlacement="top"
                              isSearchable={true}
                              styles={customStyles}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  {/* <div className="flex gap-1 items-center">
                    <input type="checkbox" placeholder="Enter Amount" onChange={(e) => setCheckbox(e.target.checked)} /> <span className="text-[14px] ">I here by agree to share my personal details with WelcomeCure to provide services and activate my registration.</span>
                  </div> */}
                  <div className="flex flex-row gap-2 sm:flex-row sm:items-center">
                    <input
                      type="checkbox"
                      onChange={(e) => setCheckbox(e.target.checked)}
                      className="w-5 h-5 min-w-[20px] min-h-[20px]  mt-1 sm:mt-0"
                    />
                    <span className="text-[14px] sm:text-[14px] leading-snug">
                      I here by agree to share my personal details with
                      WelcomeCure to provide services and activate my
                      registration.
                    </span>
                  </div>
                  <div className="flex flex-row gap-2 sm:flex-row sm:items-center">
                    {/* {teamCheckBoxDisplay && ( */}
                    <input
                      type="checkbox"
                      checked={teamConditionCheckbox}
                      // onClick={() => setTeamConditionModal(true)}
                      onChange={(e) =>
                        setTeamConditionCheckbox(e.target.checked)
                      }
                      className=" w-5 h-5 min-w-[20px] min-h-[20px] mt-1 sm:mt-0"
                    />
                    {/* )} */}
                    <a
                      onClick={() => setTeamConditionModal(true)}
                      className="underline cursor-pointer text-[14px] sm:text-[14px] leading-snug text-blue-500"
                    >
                      Terms & Conditions & Refund Policy
                    </a>
                  </div>
                  <div className="flex flex-row gap-2 sm:flex-row sm:items-center  pl-[27px]">
                    <a
                      onClick={() => setDisclaimerModal(true)}
                      className="underline cursor-pointer text-[14px] sm:text-[14px] leading-snug text-blue-500"
                    >
                      Disclaimer 
                    </a>
                  </div>
                  <div className="flex gap-2 justify-center pt-6 text-center">
                    <button
                      type="submit"
                      disabled={
                        !(branchId && checkbox && teamConditionCheckbox)
                      }
                      className={`font-bold py-4 px-12 rounded-full md:text-lg transform transition-all duration-300 shadow-lg 
                    ${
                      branchId && checkbox && teamConditionCheckbox
                        ? "bg-[#FCDD00] hover:bg-yellow-400 hover:scale-105 hover:shadow-xl text-black"
                        : "bg-[#FCDD00] text-gray-500 cursor-not-allowed "
                    }`}
                    >
                      Pay ₹{300 * (familyMembers.length + 1)} Now
                    </button>

                    {/* <button
                      type="button"
                      onClick={() => {
                        handleAddFamilyMember();
                      }}
                      className="bg-[#FCDD00] hover:bg-yellow-400 text-black font-bold py-4 px-12 rounded-full md:text-lg transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
                    >
                      Add Family Member
                    </button> */}
                  </div>
                </form>
              </div>
            </div>
          </section>

          {/* Footer */}
          <footer id="contact" className="py-16 text-white bg-gray-900">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
              <div className="grid gap-12 md:grid-cols-2">
                <div>
                  <div className="flex items-center mb-6 space-x-3">
                    <img src="data:image/png;base64,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"></img>
                  </div>

                  <h4 className="mb-4 text-2xl font-bold text-yellow-300">
                    Waiting To Welcome You Onboard!
                  </h4>
                  <p className="mb-6 leading-relaxed text-gray-300">
                    Join us on this journey towards a healthier you!
                  </p>
                </div>

                <div className="space-y-6">
                  <h4 className="mb-6 text-xl font-semibold">
                    Contact Information
                  </h4>

                  <div className="flex items-center space-x-3">
                    <Calendar className="w-5 h-5 text-blue-400" />
                    <span className="text-gray-300">
                      Monday - Saturday: 9:00 AM TO 9:00 PM
                    </span>
                  </div>

                  <div className="flex items-center space-x-3">
                    <Users className="w-5 h-5 text-blue-400" />
                    <span className="text-gray-300">Derick Fernandes</span>
                  </div>

                  <div className="flex items-center space-x-3">
                    <Phone className="w-5 h-5 text-blue-400" />
                    <a
                      href="tel:+91 7400383759"
                      className="text-gray-300 transition-colors hover:text-yellow-300"
                    >
                      +91 74003 83759
                    </a>
                  </div>

                  <div className="flex items-center space-x-3">
                    <Mail className="w-5 h-5 text-blue-400" />
                    <a
                      href="mailto:derick@welcomecure.com"
                      className="text-gray-300 transition-colors hover:text-yellow-300"
                    >
                      derick@welcomecure.com
                    </a>
                  </div>
                  <div className="flex items-center space-x-3">
                    <BanknoteArrowUp className="w-5 h-5 text-blue-400" />
                    <button
                      className="text-gray-300 transition-colors hover:text-yellow-300"
                      onClick={() => {
                        setRefundModal(true);
                      }}
                    >
                      Payment Refund
                    </button>
                  </div>
                </div>
              </div>

              <div className="pt-8 mt-12 text-center border-t border-gray-800">
                <p className="text-xs text-justify text-gray-400 sm:text-sm sm:text-center"> 
                Disclaimer : Welcome Cure is currently serving Schengen Countries, USA, UK, South Africa & India with its Global Doc-on-Call (G-DoC) offering.
Welcome Cure aims to keep adding more and more countries for the G-DoC service and better coverage and shall hence update the same from time to time.
There could be many other countries apart from the ones mentioned above. For more information and clarity on the active country list for the Welcome Cure's G-DoC service you may call us on - Derick Fernandes - <a href="tel:+91 7400383759"> +91 74003 83759</a>
                </p>
                <p className="pt-4 text-gray-400">
                  © {new Date().getFullYear()} Welcome Cure Pvt. Ltd. All rights
                  reserved.
                </p>
              </div>
            </div>
          </footer>
        </div>
        {refundModal && <VfsRefundRequest setRefundModal={setRefundModal} />}
        {teamConditionModal && (
          <TeamAndConditionsModel
            setTeamConditionModal={setTeamConditionModal}
          />
        )}
        {
          disclaimerModal &&(
            <DisclaimerModel
              setDisclaimerModal={setDisclaimerModal}
            />
          )
        }
      </>
    );
}

export default App;